module.exports = __webpack_public_path__ + "static/cp-credit-light-c26ca934bffeb832ba44c07edbc976ce.png";